const RegistrationState = {
    inProcess: 'procedowany',
    accepted: 'zaakceptowany',
    rejected: 'odrzucony',
    registered: 'wpisany na listę',
    suspended: 'decyzja wstrzymana'
};

export default RegistrationState;